import { Component, OnInit, OnDestroy } from '@angular/core';
import { PassionProjectService } from '../../services/passion-project.service';
import { NotificationService } from '../../services/notification.service';
import { PassionProjects } from '../../model/PassionProject';
import { Router } from '@angular/router';
import { identity, Subscription } from 'rxjs';
import { SharedPassionProjectService } from '../../services/shared-passion-project.service';
import { UserRole } from '../../shared/user-role';
import { finalize } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthorizationService } from 'src/app/services/authorization.service';
import { Roles } from 'src/app/auth/roles.enum';

@Component({
  selector: 'app-projects-list',
  templateUrl: './projects-list.component.html',
  styleUrls: ['./projects-list.component.scss']
})
export class ProjectsListComponent implements OnInit, OnDestroy {

  loader: boolean = false;
  passionProjectList!: PassionProjects[];
  passionProjectListSubscription!: Subscription;

  showSchBx: boolean = false;
  searchText: string = '';
  userRole: UserRole = new UserRole();
  deletePassionProjectSubscription: any;
  filterProjects: PassionProjects[];
  activateTab = '';
  activateTab1 = '';

  defaultThumbnailPic: string = environment.imageBasePath + environment.userDefaultProfilePic;
  sidebarStatus: boolean = false;
  role: string = '';
  listType: string = 'all';
  sortingList: any[] = [{ id: 1, name: 'Newest', value: 'newest' }, { id: 2, name: 'Oldest', value: 'oldest' }];
  sortBy: string = 'newest';

  // Project Status Options
  projectStatusOptions = [
    { label: 'Not started', value: 'not_started' },
    { label: 'In progress', value: 'in_progress' },
    { label: 'Completed', value: 'completed' },
    { label: 'On hold / paused', value: 'on_hold' }
  ];

  //FOR PAGINATION
  maxPageNoDisplay: number = 10;
  totalDatalength: any = 0;
  pageSize: number = 9;
  page: any = 1;
  isSearchProject: boolean = false;
  is_true:boolean = true
  archivedTab:boolean = false
  hasRoleStudentVar:string = ''
  hasRoleOrgAdmin:string = ''
  readonly ROLE_STUDENT = Roles.STUDENT;
  readonly ROLE_TEACHER = Roles.TEACHER;
  readonly ROLE_MENTOR = Roles.MENTOR;
  readonly ROLE_SUPER_ADMIN = Roles.SUPER_ADMIN;
  readonly ROLE_ORG_ADMIN = Roles.ORG_ADMIN;

    //FOR allowed USER
  allowedRole: Roles[] = [Roles.STUDENT, Roles.TEACHER, Roles.MENTOR];

  // Role-based tabs
  currentTab: string = 'active'; // For tracking active tab
  currentSubTab: string = ''; // For API subtab parameter
  studentTabs = ['assigned', 'other', 'completed'];
  teacherMentorTabs = ['active', 'other', 'completed'];
  orgAdminTabs = ['active', 'inactive', 'completed', 'archived'];
  superAdminTabs = ['active', 'inactive', 'completed', 'archived'];
  
  // API parameter mapping
  pageName: string = 'published'; // Maps to page_name
  tabName: string = 'all'; // Maps to tab (all, my_organisation, etc.)

  constructor(
    private _passionProjectService: PassionProjectService,
    private _sharedPassionProjectService: SharedPassionProjectService,
    private ns: NotificationService,
    private router: Router,
    private modalService:NgbModal,
    public perm: AuthorizationService
  ) { }

  ngOnInit() {
    this.role = this.userRole.userRole;
    this.hasRoleStudentVar = Roles.STUDENT;
    
    // Determine first tab based on role and automatically select it
    let firstTab = '';
    
    if (this.perm.userHasAnyRole(this.allowedRole, this.role)) {
      // Student/Teacher/Mentor - first tab is 'assigned' or 'active'
      firstTab = this.perm.hasRole(this.ROLE_STUDENT) ? 'assigned' : 'active';
    } else if (this.perm.hasRole(this.ROLE_ORG_ADMIN)|| this.perm.isSuperAdmin()) {
      // Org Admin or superadmin - first tab is 'active'
      firstTab = 'active';
    }

    // Call onTabChange to set all parameters correctly for the first tab
    if (firstTab) {
      this.onTabChange(firstTab);
    } else {
      this.getPassionPorjects();
    }
  }

  /**
   * Get tabs applicable to the current user role
   */
  getApplicableTabs(): string[] {
    if (this.perm.isSuperAdmin()) {
      return this.superAdminTabs;
    } else if (this.perm.hasRole(this.ROLE_ORG_ADMIN)) {
      return this.orgAdminTabs;
    } else if (this.perm.hasRole(this.ROLE_TEACHER) || this.perm.hasRole(this.ROLE_MENTOR)) {
      return this.teacherMentorTabs;
    } else if (this.perm.hasRole(this.ROLE_STUDENT)) {
      return this.studentTabs;
    }
    return [];
  }

  /**
   * Get tab label based on tab value
   */
  getTabLabel(tab: string): string {
    const tabLabels = {
      // Student tabs
      'assigned': 'Assigned Projects',
      'other': 'Other Projects',
      'completed': 'Completed Projects',
      // Teacher/Mentor/Org Admin tabs
      'active': 'Active Projects',
      'inactive': 'Inactive Projects',
      'archived': 'Archived Projects',
      // Super Admin tabs
      'published': 'Published Projects'
    };
    return tabLabels[tab] || tab;
  }

  /**
   * Get project status label
   */
  getProjectStatusLabel(status: string): string {
    const statusOption = this.projectStatusOptions.find(option => option.value === status);
    return statusOption ? statusOption.label : status;
  }

  /**
   * Handle tab change
   */
  onTabChange(tab: string) {
    this.currentTab = tab;
    this.filterProjects = [];
    this.page = 1;

    // Map tab to API parameters (page_name, tab, subtab) based on role
     if (this.perm.hasRole(this.ROLE_ORG_ADMIN) || this.perm.hasRole(this.ROLE_SUPER_ADMIN)) {
      // Org Admin || superadmin
      this.tabName = 'all';
      
      if (tab === 'active') {
        this.pageName = 'published';
        this.listType = 'published';
        this.currentSubTab = 'active_projects';
        this.activateTab = 'active_projects';
      } else if (tab === 'inactive') {
        this.pageName = 'published';
        this.listType = 'published';
        this.currentSubTab = 'inactive_projects';
        this.activateTab = 'inactive_projects';
      } else if (tab === 'completed') {
        this.pageName = 'published';
        this.listType = 'published';
        this.currentSubTab = 'completed_projects';
        this.activateTab = 'completed_projects';
      } else if (tab === 'archived') {
        // Archive has no subtab
        this.pageName = 'unpublished';
        this.listType = 'unpublished';
        this.currentSubTab = '';
        this.activateTab = 'all';
      }
    } else if (this.perm.hasRole(this.ROLE_TEACHER) || this.perm.hasRole(this.ROLE_MENTOR)) {
      // Teacher/Mentor
      this.pageName = 'published';
      this.tabName = 'my_organisation';
      this.listType = 'published';
      
      if (tab === 'active') {
        this.currentSubTab = 'active_projects';
        this.activateTab = 'active_projects';
      } else if (tab === 'other') {
        this.currentSubTab = 'other_projects';
        this.activateTab = 'other_projects';
      } else if (tab === 'completed') {
        this.currentSubTab = 'completed_projects';
        this.activateTab = 'completed_projects';
      }
    } else if (this.perm.hasRole(this.ROLE_STUDENT)) {
      // Student
      this.pageName = 'published';
      this.tabName = 'my_organisation';
      this.listType = 'published';
      
      if (tab === 'assigned') {
        this.currentSubTab = 'assigned_projects';
        this.activateTab = 'assigned_projects';
      } else if (tab === 'other') {
        this.currentSubTab = 'other_projects';
        this.activateTab = 'other_projects';
      } else if (tab === 'completed') {
        this.currentSubTab = 'completed_projects';
        this.activateTab = 'completed_projects';
      }
    }

    this.getPassionPorjects();
  }

  getPassionPorjects() {
    this.loader = true;    
    this.passionProjectListSubscription = this._passionProjectService
      .passionProjectsList(this.listType, this.sortBy, this.page, this.tabName, this.currentSubTab)
      .pipe(finalize(() => this.loader = false))
      .subscribe(
        res => {
          this.passionProjectList = res.projects;
          this.filterProjects = this.passionProjectList;
          this.totalDatalength = res.total_pages * this.pageSize;
        },
        err => this.ns.showNotification('error', err.message)
      );
  }

  hasPermission(project) {
    return this.userRole.create_permission(project);
  }

  changeSharedProject(id: string, isPublish:boolean) {
    //this.getData(id);
    localStorage.setItem('_Passion_Publish_Status', JSON.stringify(isPublish));
    this.redirect('/passion-projects/view', id);
  }

  goToEdit(id: string) {
    //this.getData(id);
    this.redirect('/passion-projects/add/', id);
  }

  getData(id) {
    const passionProject = this.passionProjectList.filter(project => project._id === id);
    if (passionProject.length > 0)
      this._sharedPassionProjectService.changePassionProject(passionProject[0]);
  }

  redirect(path: string, id: string) {
    if (id) this.router.navigate([path], { queryParams: { id } });
    else this.router.navigate([path]);
  }

  openSchBx() {
    this.showSchBx = !this.showSchBx;
  }

  questionModel = null;
  openModelDeletePro(deletePro) {
    this.questionModel = this.modalService.open(deletePro, { size: "sm", centered: true });
  }

  closeProPopup() {
    this.questionModel.close();
    this.getPassionPorjects();
  }

  

  deleteProject(id: string) {
      this.loader = true;
      this.deletePassionProjectSubscription = this._passionProjectService
        .deletePassionProject(id)
        .pipe(finalize(() => this.loader = false))
        .subscribe(
          res => {
            // this.ns.showNotification('success', res.message);
            this.ns.showNotification('success', 'Project deactivated successfully');
            this.page = 1;
            this.questionModel.close();
            this.getPassionPorjects();
          },
          err => this.ns.showNotification('error', err.message)
        );
  }

  onViewAllProject(selectedTab) {    
    this.filterProjects = [];
    if(selectedTab === 'archived'){
      this.archivedTab = true;
      this.activateTab = 'my_organisation';    
      this.listType = 'unpublished';
    } else{
      this.archivedTab = false;
      this.activateTab = selectedTab; 
      this.listType = 'published';
    }
    this.page = 1;
    this.getPassionPorjects();
  }

  onViewAllProject_admin(listType) {    
    this.filterProjects = [];
    this.listType = listType;    
    this.page = 1;
    this.getPassionPorjects();
  }

  // FILTER SIDEBAR
  openFilterSidebar() {
    this.sidebarStatus = true;
  }

  getFilterStatus(data) {
    if (data.status) {
      this.sidebarStatus = data.sidebarStatus;
    }
  }

  // FOR PAGINATION
  onPageChanged(page: string) {
    this.page = parseInt(page, 10) || 1;
    this.getPassionPorjects();
  }

  // FOR SORT DATA
  onSortData(event) {
    this.sortBy = event.target.value;
    this.page = 1;
    this.getPassionPorjects();
  }

  // FOR SEARCH PROJECT
  onStartSearch(data) {
    this.page = 1;
    if(this.role == this.ROLE_STUDENT || this.role == this.ROLE_TEACHER){
      this.listType = (this.role == this.ROLE_STUDENT || this.role == this.ROLE_TEACHER) ? 'published' : 'all';
    }
    this.sortBy = 'newest';
    this.searchText = data.searchText;
    if (this.searchText) {
      this.isSearchProject = true;
      this.getSearchPassionPorjects();
    }
    else {
      this.isSearchProject = false;
      this.getPassionPorjects();
    }
  }

  getSearchPassionPorjects() {
    this.loader = true;
    this.passionProjectListSubscription = this._passionProjectService
      .searchPassionProjectsList(this.searchText)
      .subscribe(
        res => {
          this.loader = false
          this.passionProjectList = res.response
          this.filterProjects = this.passionProjectList;
          this.totalDatalength = res.response.length;
        },
        err => {
          this.loader = false
          this.ns.showNotification('error', err.message);
          console.log(err);
        }
      );
  }

  ngOnDestroy() {
    this.passionProjectListSubscription.unsubscribe();
    if (this.deletePassionProjectSubscription) this.deletePassionProjectSubscription.unsubscribe();
  }
}
